var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Route, Switch } from 'react-router-dom';
import React from 'react';
import CollaboratorPacketsTable from './container/CollaboratorPacketsTable';
import CollaboratorPacketsFormEdit from './container/CollaboratorPacketsFormEdit';
var Index = function () {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: '/collaboratorpackets', component: CollaboratorPacketsTable }),
        React.createElement(Route, { exact: true, path: "/collaboratorpackets/:operator_id/:packet_id", render: function (props) { return React.createElement(CollaboratorPacketsFormEdit, __assign({}, props)); } })));
};
export default Index;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPackets/index.tsx
// module id = 1608
// module chunks = 0